import moment from 'moment';

const getExternalTooltipDateRange = (dateFrom, dateTo) =>
  `${moment(dateFrom).format('DD.MM.YYYY')} - ${moment(dateTo).format(
    'DD.MM.YYYY'
  )}`;

export default getExternalTooltipDateRange;
